import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from './authprovider'

export default function ProtectedRoute() {
  const { isAuthenticated } = useAuth()
  return isAuthenticated
    ? <Outlet/>
    : <Navigate to="/signin" replace/>
}